import { useUiConfig } from "adl-service/hooks/use-ui-config";
import { useContext } from "react";
import { isAdmin } from "utils/user-utils";
import { LoggedInContext } from "../app/app";

export function useEmailPanelControls() {
  const { emailIntelligenceConfig } = useUiConfig();
  const loggedInUserContext = useContext(LoggedInContext);
  const userProfile = loggedInUserContext.loginState?.user?.profile;
  const userIsAdmin = userProfile ? isAdmin(userProfile) : false;
  const authToken = loggedInUserContext.loginState?.token || "";
  return {
    showEmailPanel: userIsAdmin && emailIntelligenceConfig.enable,
    authToken,
  };
}
